<template>
    <div class="uk-card uk-card-default uk-card-body uk-margin-small uk-padding-small uk-border-rounded uk-box-shadow-medium">
        <slot />
    </div>
</template>

<script>
    export default {
        name: "PanelBox"
    }
</script>

<style scoped>

</style>
